import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { componentKey, setLoadingState, setPurchasePlanDetails, setUserPlanReminderData  } from './ChangePlanSlice';
import PaymentDataService from '../../../../services/PaymentDataService';
import { PLAN_LOADING_STATES } from '../../constants/constants';
import { CHANGE_PLAN_LOADING_STATES } from './Constants';

export const { getPlanDetails, getUserPlanExpiryDate } = {
	getPlanDetails: (payload) => {
        return {
            type: "PLANS/GET_PLAN_DETAILS",
            payload: payload
        }
    },
    getUserPlanExpiryDate: (payload)=>{
        return {
            type: 'PLANS/GET_USER_PLAN_EXPIRE_DATE',
            payload
        }
    }
}

function* getPlanDetailsAsync(action) {
    try {
        yield put(setLoadingState({ state: PLAN_LOADING_STATES.PLANS_LOADING, message: "Fetching Plans Amount" }));

        const response = yield PaymentDataService.getPurchasePlanAmounts();
        
        if (response?.data.Status === 1) {
            yield put(setPurchasePlanDetails(response?.data.Data));
        } else {
            yield put(addNotifications({ heading: "Failed to get the Plans Amount", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the Plans Amount", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PLAN_LOADING_STATES.PLANS_READY }))
    }
}

function* getUserPlanExpiryDateAsync(action) {
    try {
        yield put(setLoadingState({ state: CHANGE_PLAN_LOADING_STATES.GET_USER_PLAN_EXPIRY_DATE_LOADING }));
        const response = yield PaymentDataService.getUserPlanExpiryDate(action.payload)

        const { Status, Message, Data } = response.data

        if (Status) {
            yield put(setUserPlanReminderData(Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
        }));
    } finally {
        yield put(setLoadingState({ state: CHANGE_PLAN_LOADING_STATES.GET_USER_PLAN_EXPIRY_DATE_READY }));
    }
}

function* rootSaga() {
	yield all([
		takeLatest(getPlanDetails().type, getPlanDetailsAsync),
        takeLatest(getUserPlanExpiryDate().type, getUserPlanExpiryDateAsync)
	]);
}

store.sagaManager.addSaga(componentKey, rootSaga);